<template>
  <div>
    <div class="show-navbar-mobile">
      <cash-hero-navbar :bright="true" />
    </div>
    <div class="cashhero-container">
      <div class="col-md-12 col-lg-12 px-md-0">
        <div class="cashhero-wrap">
          <div class="cashhero-block-form">
            <div class="cashhero-form-creat">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="cashhero-form-title">
                    {{ $t('button.login') }}
                  </h2>
                  <h2 class="cashhero-form-title-mobile">
                    CashHero
                  </h2>
                  <p class="cashhero-form-sub-title">
                    {{ $t('strings.welcomeBack') }}
                  </p>
                </div>
                <div class="col-md-12">
                  <div
                    v-if="isLoginFail"
                    class="alert alert-danger alert-dismissible"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      style="margin-bottom: 0"
                      aria-label="Close"
                      @click="isLoginFail = false"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    {{ messageError }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="cashhero-field cashhero-a-field cashhero-a-field_a1">
                      {{ $t('form.borrow.phone') }}
                    </label>
                    <input
                      v-model="phone"
                      v-mask="'0## ### ####'"
                      type="text"
                      class="form-control"
                    >
                    <small
                      class="label-error has-error form-text"
                      v-if="validations !== null && validations.hasOwnProperty('username')"
                    >
                      {{ validations['username'][0] }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="cashhero-field cashhero-a-field cashhero-a-field_a1">
                      {{ $t('fields.label.password') }}
                    </label>
                    <input
                      v-model="credentials.password"
                      type="password"
                      class="form-control"
                    >
                    <small
                      class="label-error has-error form-text"
                      v-if="validations !== null && validations.hasOwnProperty('password')"
                    >
                      {{ validations['password'][0] }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row btn-row mt2rem">
                <div class="col-md-12">
                  <button
                    class="btn btn-cash-hero capitalize btn-block"
                    @click="login"
                  >
                    {{ $t('button.login') }}
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-4 no-padding">
                  <button
                    class="btn btn-link float-left"
                    style="color: var(--primary)"
                    @click="$router.push({name: 'home'})"
                  >
                    {{ $t('button.back') }}
                  </button>
                </div>
                <div class="col-8 no-padding">
                  <button
                    class="btn btn-link float-right"
                    @click="forgetPassword"
                    style="color: var(--primary)"
                  >
                    {{ $t('label.forgetPassword') }}
                  </button>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-12"
                  style="margin-top: 10%"
                >
                  <p
                    class="text-center"
                    style="margin-bottom: 0"
                  >
                    {{ $t('string.cashheroColLTD') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="cashhero-block-left">
            <div class="block-left-bg">
              <img
                class="icon-image"
                src="/img/logo.png"
                alt="logo.png"
              >
              <img
                class="sheet-image"
                src="/img/background/Spreadsheets-bro.svg"
                alt="Spreadsheets-bro.svg"
              >
              <div class="block-left-content">
                <p class="mb-4">
                  {{ $t('login.left.desc') }}
                </p>
                <button
                  class="btn btn-outline-white"
                  @click="backHome"
                >
                  {{ $t('button.backToHome') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CashHeroNavbar from '@/partials/CashHeroNavbar'
export default {
  name: 'LoginVersion2',
  components: { CashHeroNavbar },
  data () {
    return {
      isLoginFail: false,
      messageError: '',
      credentials: {
        grant_type: 'password',
        username: '',
        password: '',
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET
      },
      validations: null,
      phone: null
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function () {
        this.validations = null
      }
    }
  },
  methods: {
    backHome () {
      // change redirect to home page
      this.$router.push({ name: this.$default_page })
    },
    login () {
      this.isLoginFail = false
      this.validations = null
      this.credentials.username = ''
      this.$isLoading(true)
      if (this.phone) {
        this.credentials.username = '855' + this.phone.replace(/\s+/g, '').substring(1)
      }
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/login', this.credentials)
        .then((response) => {
          if (response.data.code === 1) {
            var result = response.data.data
            var token = result.token_type + ' ' + result.access_token
            if (result.user.phone) {
              result.user.phone = result.user.phone.replace('855', '0')
            }
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(result.user))
            this.$axios.defaults.headers.common.Authorization = token
            this.$store.dispatch('checkUserLogin', true)
            this.$store.dispatch('setDataBorrower', result.user)
            this.$store.dispatch('setAvatar', result.user.avatar)
            this.$router.push({ name: 'profile', params: { activeTabs: 'profile' } })
          } else {
            if (response.data.hasOwnProperty('message')) {
              this.validations = response.data.message
            } else {
              this.isLoginFail = true
              this.$i18n.locale === 'km' ? this.messageError = response.data.message_km : this.messageError = response.data.message_en
            }
          }
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    forgetPassword () {
      sessionStorage.setItem('fromPage', 'forget-password')
      this.$router.push({ name: 'input-phone-number', params: { fromPage: sessionStorage.getItem('fromPage') } })
    },
    onPressEnter (e) {
      if (e.code === 'Enter') {
        this.login()
      }
    }
  },
  mounted () {
    window.addEventListener('keypress', this.onPressEnter)
  },
  destroyed () {
    window.removeEventListener('keypress', this.onPressEnter)
  }
}
</script>

<style scoped>
@import "../../../assets/styles/login.css";
.cashhero-container {
  padding: 0; /* none */
}

.show-navbar-mobile {
  display: none;
}

.cashhero-wrap {
  min-height: 100vh; /* min-height: 650px; */
  border-radius: unset; /* none */
}

.cashhero-block-left,
.cashhero-block-form {
  width: 50%;
}

.cashhero-block-left,
.cashhero-block-form,
.block-left-bg {
  min-height: 100%;
}

.cashhero-block-form {
  padding: 255px 30px; /* padding: 100px 30px; */
}

.cashhero-form-title-mobile {
  display: none;
}

/* .block-left-bg {
  background-color: var(--primary);
}*/
.cashhero-block-left {
  padding: 70px 30px;
  background-color: var(--primary);
}

.icon-image {
  width: 35%;
  margin: 30px;
}
.block-left-bg .sheet-image{
  width: 45%;
  display: block;
  margin: auto;
}

.block-left-content,
.cashhero-form-creat {
  width: 75%;
  margin: 0 auto;
}

.block-left-content {
  color: white;
  text-align: center;
}

@media (max-width: 1600px) {
  .block-left-bg .sheet-image {
    width: 55%;
  }
}

@media (max-width: 1200px) {
  .block-left-bg .sheet-image {
    width: 75%;
  }
}

@media (max-width: 991.89px) {
  .cashhero-wrap {
    margin: 0 auto;
  }

  .cashhero-form-creat {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .cashhero-wrap {
    margin: 15vh auto 0;
  }

  .show-navbar-mobile {
    display: block;
  }

  .cashhero-block-left {
    display: none;
  }

  .cashhero-wrap {
    min-height: 500px;
  }

  .cashhero-block-form {
    width: 100%;
    padding: 30px;
  }

  .cashhero-form-title {
    display: none;
  }

  .cashhero-form-title-mobile {
    display: block;
    color: black;
    text-align: center;
    font-family: 'Times New Roman',serif !important;
    font-weight: bold;
    font-size: 34px !important;
  }
}
</style>
